import React from 'react';

export default function IconDK() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 23">
            <path
                fill="#FF4B55"
                d="M31.448 22.31H.552A.56.56 0 0 1 0 21.741V1.26a.56.56 0 0 1 .552-.57h30.896a.56.56 0 0 1 .552.57V21.74a.56.56 0 0 1-.552.57Z"
            />
            <path
                fill="#F5F5F5"
                d="M32 9.793H13.24V.69h-3.31v9.103H0v3.414h9.93v9.103h3.311v-9.103H32V9.793Z"
            />
        </svg>
    );
}
